// extracted by mini-css-extract-plugin
export default {"container":"styles-module__container__src-labstep-web-components-Entity-Search-_qjL_o","children":"styles-module__children__src-labstep-web-components-Entity-Search-_Tr8Mv"};